/**
 * argile-boutique-soeur.js — le sélecteur de langue envoie sur la vitrine qui sert le visiteur.
 *
 * Sur le `.com`, un visiteur détecté au Royaume-Uni qui choisit « English » part sur
 * `argile-peinture.co.uk`, à la page équivalente, plutôt que sur `.com/en` — qui lui afficherait
 * des prix en euros et refuserait de le livrer depuis le 21/09.
 *
 * ⚠️ RIEN NE S'AFFICHE. Aucun bandeau, aucune sollicitation : on change la destination d'une
 *    option que le visiteur doit ouvrir lui-même. Qui ne touche pas au sélecteur ne voit aucune
 *    différence. Et surtout AUCUNE REDIRECTION : voir le commentaire du snippet.
 *
 * ⚠️ LE SCRIPT ÉCHOUE EN SILENCE, TOUJOURS. Géolocalisation indisponible, stockage refusé,
 *    réponse inattendue, sélecteur absent : on ne touche à rien. Ne rien faire est sans
 *    conséquence ; réorienter à tort enverrait un client vers une boutique qui ne le livre pas.
 */
(function () {
  const config = window.ArgileBoutiqueSoeur;
  if (!config || !config.url || !config.pays || !config.langue) return;

  const CLE_PAYS = 'argile-soeur-pays';

  /** Lecture/écriture tolérantes : navigation privée, stockage bloqué, quota plein. */
  function lire(cle) {
    try {
      return window.sessionStorage.getItem(cle);
    } catch (e) {
      return null;
    }
  }
  function ecrire(cle, valeur) {
    try {
      window.sessionStorage.setItem(cle, valeur);
    } catch (e) {
      /* sans effet : le script refera simplement son appel à la page suivante */
    }
  }

  /**
   * Pays du visiteur, d'après son IP.
   *
   * ⚠️ `detected_values` est bien le pays DU VISITEUR, pas le marché courant. C'est la
   *    distinction qui fait tout : depuis le 21/09 le Royaume-Uni n'est plus un marché de la
   *    boutique française, donc `localization.country` y répond « France » pour un Britannique.
   *    Cet endpoint, lui, répond « GB ».
   *
   * La surcharge `?argile-pays=GB` existe pour la recette : personne en France ne peut voir la
   * version britannique autrement. Elle ne change que la destination d'une option.
   */
  function paysDuVisiteur() {
    const force = new URLSearchParams(window.location.search).get('argile-pays');
    if (force) return Promise.resolve(force.toUpperCase());

    const enCache = lire(CLE_PAYS);
    if (enCache) return Promise.resolve(enCache);

    return fetch('/browsing_context_suggestions.json?source=geolocation_recommendation&show_all_countries=false', {
      headers: { Accept: 'application/json' },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        const pays = data && data.detected_values && data.detected_values.country;
        const code = pays && pays.handle ? String(pays.handle).toUpperCase() : null;
        if (code) ecrire(CLE_PAYS, code);
        return code;
      })
      .catch(() => null);
  }

  /**
   * Les sélecteurs de langue (pied de page, et en-tête depuis le 22/10) sont des <select> dont
   * chaque option porte son URL cible en valeur, rendus par `snippets/argile-selecteur-langue.liquid`
   * et marqués `data-argile-langue`. Dans chacun, on remplace l'option de la langue d'en face par
   * l'URL de la boutique sœur, et on dit dans le libellé qu'on change de site (« EN (UK) »).
   */
  function reorienterLesSelecteurs() {
    const options = document.querySelectorAll('[data-argile-langue] option[lang="' + config.langue + '"]');
    const mention = config.mention || '';
    options.forEach(function (option) {
      // Si cette langue est celle de la page, l'option est la ligne « vous êtes ici » : on n'y touche pas.
      if (option.selected) return;
      option.value = config.url;
      if (mention && option.textContent.indexOf(mention) === -1) {
        option.textContent = option.textContent + mention;
      }
    });
  }

  paysDuVisiteur().then(function (pays) {
    if (pays !== config.pays) return;
    reorienterLesSelecteurs();
  });
})();
